<template>
  <section class="section section-home">
    <div class="tech-bg">
      <div class="grid-overlay"></div>
      <div class="floating-particles">
        <div class="particle" v-for="n in 30" :key="n" :style="particleStyle(n)"></div>
      </div>
      <div class="glow-orb glow-orb-1"></div>
      <div class="glow-orb glow-orb-2"></div>
      <div class="glow-orb glow-orb-3"></div>
      <div class="hex-grid"></div>
    </div>

    <div class="hero">
      <h1>AI 时代，<br>一个人就是一家公司</h1>
      <p class="sub-title">无需团队、无需融资、无需资源，用 AI 构建属于你的商业系统</p>
      <div class="hero-buttons">
        <button class="btn primary">功能介绍</button>
        <button class="btn second" @click="openRegister">免费注册</button>
      </div>
    </div>

    <div class="features">
      <div class="feature-item">
        <div class="icon">🤖</div>
        <h3>AI 全能助理</h3>
        <p>文案、脚本、直播、运营、编程一站式支持</p>
      </div>
      <div class="feature-item">
        <div class="icon">⚡</div>
        <h3>零门槛上手</h3>
        <p>无需专业技能，简单配置即可启动所有功能</p>
      </div>
      <div class="feature-item">
        <div class="icon">💰</div>
        <h3>低成本创业</h3>
        <p>一人即可完成团队工作，大幅降低创业成本</p>
      </div>
    </div>

    <div class="features">
      <div class="feature-item">
        <div class="icon">🎬</div>
        <h3>AI 视频生成</h3>
        <p>文生视频、图生视频、数字人对口型，一键生成专业视频</p>
      </div>
      <div class="feature-item">
        <div class="icon">🖼️</div>
        <h3>AI 图片生成</h3>
        <p>文生图、图生图，多种风格模型，满足不同场景需求</p>
      </div>
      <div class="feature-item">
        <div class="icon">💻</div>
        <h3>AI 编码助手</h3>
        <p>智能生成代码，提高开发效率，减少重复工作</p>
      </div>
    </div>

    <div class="features">
      <div class="feature-item">
        <div class="icon">📝</div>
        <h3>AI 文案创作</h3>
        <p>自动生成营销文案、社交媒体内容、产品描述</p>
      </div>
      <div class="feature-item">
        <div class="icon">🎯</div>
        <h3>AI 数据分析</h3>
        <p>智能分析业务数据，提供数据驱动的决策建议</p>
      </div>
      <div class="feature-item">
        <div class="icon">🚀</div>
        <h3>AI 营销工具</h3>
        <p>自动化营销流程，提高转化率，降低获客成本</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    openRegister() {
      // 触发父组件的注册弹窗
      this.$emit('open-register')
    },
    particleStyle() {
      return {
        left: Math.random() * 100 + '%',
        top: Math.random() * 100 + '%',
        animationDelay: Math.random() * 8 + 's',
        animationDuration: (4 + Math.random() * 6) + 's',
        opacity: 0.2 + Math.random() * 0.6
      }
    }
  }
}
</script>

<style scoped>
/* 科技背景 */
.section-home {
  text-align: center;
  box-sizing: border-box;
  min-height: 100vh;
  padding-top: 100px !important;
  padding-bottom: 60px !important;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #0a0e1a 0%, #0d1224 50%, #0a0e1a 100%);
}

.tech-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(0, 230, 172, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 230, 172, 0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, black 20%, transparent 70%);
  -webkit-mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, black 20%, transparent 70%);
}

.hex-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='49' viewBox='0 0 28 49'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%2300e6ac' fill-opacity='0.02'%3E%3Cpath d='M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.5;
}

.floating-particles {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.particle {
  position: absolute;
  width: 2px;
  height: 2px;
  background: #00e6ac;
  border-radius: 50%;
  box-shadow: 0 0 6px #00e6ac, 0 0 12px rgba(0, 230, 172, 0.3);
  animation: float-particle-home 6s ease-in-out infinite;
}

@keyframes float-particle-home {
  0%, 100% { opacity: 0; transform: translateY(0) scale(0); }
  25% { opacity: 1; transform: translateY(-30px) scale(1); }
  75% { opacity: 0.5; transform: translateY(-60px) scale(0.5); }
}

.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  pointer-events: none;
}

.glow-orb-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(0, 230, 172, 0.08), transparent 70%);
  top: 5%;
  left: 20%;
  animation: orb-float-1 12s ease-in-out infinite;
}

.glow-orb-2 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(0, 150, 255, 0.06), transparent 70%);
  top: 40%;
  right: 10%;
  animation: orb-float-2 10s ease-in-out infinite;
}

.glow-orb-3 {
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(138, 43, 226, 0.05), transparent 70%);
  bottom: 10%;
  left: 40%;
  animation: orb-float-3 14s ease-in-out infinite;
}

@keyframes orb-float-1 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(50px, 30px) scale(1.1); }
  66% { transform: translate(-30px, -20px) scale(0.9); }
}

@keyframes orb-float-2 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(-40px, 50px) scale(1.15); }
  66% { transform: translate(30px, -40px) scale(0.85); }
}

@keyframes orb-float-3 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(60px, -30px) scale(1.1); }
  66% { transform: translate(-50px, 40px) scale(0.95); }
}

/* 让内容在背景上方 */
.hero, .features {
  position: relative;
  z-index: 1;
}

.hero {
  position: relative;
}

.hero::before {
  content: '';
  position: absolute;
  top: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 400px;
  background: radial-gradient(ellipse, rgba(0, 230, 172, 0.1), transparent 70%);
  filter: blur(40px);
  pointer-events: none;
  z-index: -1;
}

.hero h1 {
  font-size: 48px;
  line-height: 1.2;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #fff 0%, #e6f1ff 50%, #00e6ac 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
}

.sub-title {
  font-size: 18px;
  color: #aaa;
  max-width: 650px;
  margin: 0 auto 40px;
}

.hero-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 60px;
}

.features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 40px;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
}

.feature-item {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.05);
  border-radius: 16px;
  padding: 40px 24px;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  position: relative;
  overflow: hidden;
}

.feature-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 230, 172, 0.03), transparent);
  transition: left 0.6s ease;
}

.feature-item:hover::before {
  left: 100%;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2), 0 0 20px rgba(0, 230, 172, 0.05);
  border-color: rgba(0,230,172,0.2);
}

.feature-item .icon {
  font-size: 36px;
  margin-bottom: 20px;
}

.feature-item h3 {
  font-size: 18px;
  margin-bottom: 12px;
}

.feature-item p {
  color: #888;
  font-size: 14px;
}

/* 响应式 */
@media (max-width: 768px) {
  .features {
    grid-template-columns: 1fr;
  }
  .hero h1 {
    font-size: 36px;
  }
  .glow-orb-1, .glow-orb-2, .glow-orb-3 {
    display: none;
  }
}
</style>
